import type { GuestStatus, PersonalMessageStatus, RsvpStatus } from "@anggunpraya-templates/types";
import { z } from "zod";

const rsvpStatusEnum = z.enum(["attending", "not-attending", "pending"], {
  error: "Status kehadiran harus diisi",
}) as z.ZodType<RsvpStatus>;

const guestStatusEnum = z.enum(["unconfirmed", "attending", "not-attending"], {
  error: "Status kehadiran harus diisi",
}) as z.ZodType<GuestStatus>;

const personalMessageStatusEnum = z.enum(["attending", "not-attending", ""]) as z.ZodType<PersonalMessageStatus>;

/**
 * Schema request untuk konfirmasi RSVP guest.
 *
 * Dipakai sebagai kontrak runtime di form RSVP lintas template.
 */
export const eventRsvpConfirmation = z.object({
  status: guestStatusEnum,
  rsvp_activities: z.array(z.object({
    egra_id: z.string().min(1, {
      error: "ID aktivitas RSVP harus diisi",
    }),
    rsvp_status: rsvpStatusEnum,
    pax: z.number({
      error: "Jumlah pax harus berupa angka",
    }),
    rsvp_activity: z.object({
      name: z.string().min(1, {
        error: "Nama aktivitas RSVP harus diisi",
      }),
    }),
  }).superRefine((data, ctx) => {
    if (data.rsvp_status === "attending" && !data.pax) {
      ctx.addIssue({
        code: "custom",
        message: "Jumlah pax harus diisi",
        path: ["pax"],
      });
    }
  })),
});

/**
 * Tipe output hasil infer dari schema `eventRsvpConfirmation`.
 */
export type EventRsvpConfirmationBody = z.output<typeof eventRsvpConfirmation>;

/**
 * Schema request untuk personal message / wishes.
 */
export const eventPersonalMessage = z.object({
  media_id: z.string().nullable(),
  event_guest_id: z.string().nullable(),
  status: personalMessageStatusEnum,
  guest_name: z.string().min(1, {
    error: "Nama pengirim tidak boleh kosong",
  }),
  message: z.string().min(1, {
    error: "Pesan tidak boleh kosong",
  }),
}).superRefine((data, ctx) => {
  if (data.event_guest_id === null && !data.status) {
    ctx.addIssue({
      code: "custom",
      message: "Status kehadiran harus diisi",
      path: ["status"],
    });
  }
});

/**
 * Tipe output hasil infer dari schema `eventPersonalMessage`.
 */
export type EventPersonalMessageBody = z.output<typeof eventPersonalMessage>;
